var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.27143 1.10246C4.44203 0.751901 4.79272 0.533203 5.175 0.533203H8.97885C9.36113 0.533203 9.71181 0.751901 9.88242 1.10246L10.1099 1.56237H13.1429C13.7021 1.56237 14.1538 2.02228 14.1538 2.59154C14.1538 3.16079 13.7021 3.6207 13.1429 3.6207H1.01099C0.451786 3.6207 0 3.16079 0 2.59154C0 2.02228 0.451786 1.56237 1.01099 1.56237H4.04396L4.27143 1.10246ZM1.01099 4.64987H13.1429V14.9415C13.1429 16.0768 12.2361 16.9999 11.1209 16.9999H3.03297C1.91772 16.9999 1.01099 16.0768 1.01099 14.9415V4.64987ZM4.04396 6.7082C3.76593 6.7082 3.53846 6.93977 3.53846 7.22279V14.427C3.53846 14.71 3.76593 14.9415 4.04396 14.9415C4.32198 14.9415 4.54945 14.71 4.54945 14.427V7.22279C4.54945 6.93977 4.32198 6.7082 4.04396 6.7082ZM7.07692 6.7082C6.7989 6.7082 6.57143 6.93977 6.57143 7.22279V14.427C6.57143 14.71 6.7989 14.9415 7.07692 14.9415C7.35494 14.9415 7.58242 14.71 7.58242 14.427V7.22279C7.58242 6.93977 7.35494 6.7082 7.07692 6.7082ZM10.1099 6.7082C9.83187 6.7082 9.60439 6.93977 9.60439 7.22279V14.427C9.60439 14.71 9.83187 14.9415 10.1099 14.9415C10.3879 14.9415 10.6154 14.71 10.6154 14.427V7.22279C10.6154 6.93977 10.3879 6.7082 10.1099 6.7082Z",
    fill: "#5E06B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/TrashIcon.b2d3c16245191d58ea13590512a52878.svg";
export { ForwardRef as ReactComponent };